import Items from './Items'

module.exports = Items.reducer( null, 'API_ACCESS', 'projectId', [ 'projectId' ] )
